<template>
  <transition key="modal" name="modal">
    <div class="modal-mask modal-base">
      <div class="modal-wrapper">
        <div class="modal-container modal-center">
          <slot name="header"></slot>
          <br>
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'ModalBase',
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/modal_base.vue?10441818